/**
 * The `page` property shared by the paywall funnel events (`paywall-viewed` →
 * `checkout-clicked`). Both ends must normalize identically or the funnel can't
 * be joined per page.
 *
 * Umami groups event properties by value, so the per-template routes would blow
 * the breakdown up into hundreds of near-empty rows.
 */
export const normalizePage = (pathname: string) =>
	pathname.startsWith("/templates/") ? "/templates" : pathname;
